<template>
  <div class="modal">
    <div class="disclaimer__container">
      <div class="block">
        <div class="block__header">
          <h2 class="block__title">{{ getResource('RicohImagingDisclaimerTitle') }}</h2>
        </div>
        <div class="block__content block__content--disclaimer">
          {{{ getResource('RicohImagingDisclaimerText') }}}
          <div>
		    <button class="button" v-on:click="approveDisclaimer">Approve</button>
          </div>
        </div>
      </div>
    </div>
  </div>
 </template>
<script>
import { approveDisclaimer } from "./NavigationActions";
import { getResource } from "../../vuex/helpers";

export default {
  vuex: {
    getters: {
      menu: state => state.menu,
      showDisclaimer: state => state.showDisclaimer
    },
    actions: { approveDisclaimer, getResource }
  },
  components: {},
  data: function () {
    return {
      pageNumber: 0
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .modal {
  	position: fixed;
  	top: 0;
  	left: 0;
  	right: 0;
  	bottom: 0;
  	background: rgba(1,1,1,0.9);
    z-index: 2000;
  }

  .block__content--disclaimer{
    @include clear-fix;
    padding-bottom: 30px;
    color: $white;
	
	a {
      color: $white;
	  text-decoration: underline;
	}	
	div {
      margin-top: 20px
	}
  }

	.disclaimer__container {
		border: 0px solid transparent;
    box-sizing: border-box;
    display: block;
		margin: 0 auto;
		margin-top:10%;
		overflow: hidden;
    width: 70%;
	}

  @media only screen and (max-height: 768px)
  {
	.disclaimer__container {
		width: 90%;
		margin-top: 5%;
	}
	
	.disclaimer__container h2 {
		font-size: 25px;
	}	
	
	.block__content {
		padding: 30px;
	}
	
	.block__header {
		padding: 15px 40px 10px;
	}
	
	.disclaimer__container .icon-button {
		width: 40px;
		height: 35px;
	}
	
    .disclaimer__container .close-green:before{
		left: 10px;
    }	
  }

  .close-green{
    position: relative;

    &:before{
      content: "+";
      color: $green;
      font-size: 30px;
      line-height: 30px;
      position: absolute;
      left: 18px;
      top: 3px;

      transform: rotate(45deg);
    }
  }
</style>


// WEBPACK FOOTER //
// Disclaimer.vue?3a54df88